import i18n from 'shared/i18n';

import HandshqApp from './handshq-app';

HandshqApp.datepicker = {
  setup() {
    const _this = this;

    this.projectStartDate = $('input#project_start_date');
    this.projectEndDate = $('input#project_end_date');
    this.projectForm = $('.project-form');

    this.initDatePicker(_this.projectStartDate, {
      todayHighlight: true,
      container: _this.projectForm,
    });
    this.initDatePicker(_this.projectEndDate, { container: _this.projectForm });
    this.initDatePicker($('.nadmin-content .field .date_field'));
    this.initDatePicker($('.project-form .field .date_field'), {
      container: _this.projectForm,
    });
    this.initDatePicker($('.pickable-date-field'));

    if (_this.projectStartDate.length && _this.projectEndDate.length) {
      this.projectStartDateOnChange();
    }
  },

  initDatePicker(elements, options) {
    const defaultOptions = {
      autoclose: true,
      clearBtn: true,
      format: 'dd/mm/yyyy',
      language: i18n.language,
      weekStart: 1,
    };

    $.extend(defaultOptions, options);
    elements.datepicker(defaultOptions);
  },

  projectStartDateOnChange() {
    const _this = this;

    _this.projectStartDate.datepicker().on('changeDate', () => {
      const startDate = _this.projectStartDate.datepicker('getDate');

      _this.projectEndDate.datepicker('setStartDate', startDate);
    });
  },
};

$(() => {
  HandshqApp.datepicker.setup();
});
